import { FunctionComponent } from 'preact';
import { useCallback, useState } from 'preact/hooks';

import { Button, ButtonProps } from '../Button/Button';
import { usePlayer } from '../../hooks/PlayerProvider';

const PLAYBACK_SPEEDS = [0.5, 1, 1.25, 1.5, 2];

export const PlaybackSpeedButton: FunctionComponent<
  Omit<ButtonProps, 'onClick'>
> = (props) => {
  const player = usePlayer();
  const [playbackSpeed, setPlaybackSpeed] = useState(
    () => player.getPlaybackRate() ?? 1
  );

  const handleClick = useCallback(() => {
    const currentIndex = PLAYBACK_SPEEDS.indexOf(playbackSpeed);
    const nextIndex = (currentIndex + 1) % PLAYBACK_SPEEDS.length;
    const nextSpeed = PLAYBACK_SPEEDS[nextIndex];
    player.setPlaybackRate(nextSpeed);
    setPlaybackSpeed(nextSpeed);
  }, [player, playbackSpeed]);

  return (
    <Button onClick={handleClick} {...props}>
      {playbackSpeed}x
    </Button>
  );
};
